/**
 * Извлекает сообщение об ошибке из axios/RPC ответа.
 * Поддерживает вложенные структуры: response.data.error.message, response.data.message, error.message.
 *
 * @param error — перехваченная ошибка (unknown)
 * @param fallback — сообщение по умолчанию, если извлечь не удалось
 */
export function extractErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error) {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const axiosError = error as any;
    if (axiosError.response?.data?.error?.message) return axiosError.response.data.error.message;
    if (axiosError.response?.data?.message) return axiosError.response.data.message;
    return error.message;
  }
  return fallback;
}
